import type { TOC } from '@ember/component/template-only'
import { StudentDashboardTile } from 'teacher-ui-client/components/tiles/student-dashboard'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { t } from 'ember-intl'
import { TaskState } from 'teacher-ui-client/components/task-state'
import type {
  AssignmentsEventsReportData,
  AssignmentsOverviewReportData,
} from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'
import type { Task } from 'ember-concurrency'
import { DashboardStudentAssignmentsOverview } from 'teacher-ui-client/components/reporting/reading-eggspress/dashboard/student/assignments/overview'
import { DashboardStudentAssignmentsEventsDetailed } from 'teacher-ui-client/components/reporting/reading-eggspress/dashboard/student/assignments/events-detailed'
import { StudentDashboardSubheader } from 'teacher-ui-client/components/tiles/student-dashboard/subheader'
import { BasePageSelector } from 'teacher-ui-client/components/base/page-selector'

interface Args {
  fetchAssignmentsOverviewReportTask: Task<AssignmentsOverviewReportData | undefined, unknown[]>
  fetchAssignmentsEventsReportTask: Task<AssignmentsEventsReportData | undefined, unknown[]>
}

interface Signature {
  Args: Args
}
export const DashboardStudentAssignmentsPage: TOC<Signature> = <template>
  <StudentDashboardTile
    data-test-student-dashboard-tile="assignments"
    @theme={{themeKey "reading"}}
    @title={{t "pages.reporting.readingEggspress.dashboard.student.assignments.title"}}
    @icon="phosphor-share-network-fill"
  >
    <TaskState @task={{@fetchAssignmentsOverviewReportTask}} @initialLoadingClass="m-3" as |lastValue isRunning|>
      <DashboardStudentAssignmentsOverview
        class="w-full"
        @overviewData={{lastValue.overview}}
        @isLoading={{isRunning}}
      />
    </TaskState>
    <StudentDashboardSubheader>
      {{t "pages.reporting.readingEggspress.dashboard.student.recentActivity"}}
    </StudentDashboardSubheader>
    <TaskState @task={{@fetchAssignmentsEventsReportTask}} @initialLoadingClass="m-3" as |lastValue isRunning|>
      <DashboardStudentAssignmentsEventsDetailed
        class="w-full"
        @eventsData={{lastValue.events}}
        @isLoading={{isRunning}}
      />
      <BasePageSelector
        class="my-4"
        @pageCount={{lastValue.meta.total_pages}}
        @itemCount={{lastValue.meta.total_entries}}
      />
    </TaskState>
  </StudentDashboardTile>
</template>

export default DashboardStudentAssignmentsPage
